import { Link } from "react-router-dom";
import { Bike } from "lucide-react";
import { DELIVERY_APPS, DELIVERY_BAND } from "../data/nap";
import { useCart } from "../context/CartContext";

// Brand-level delivery band for trading brands only (restaurant, express). Direct delivery first, apps as the alternative.
export function DeliveryBand({ testPrefix = "delivery-band" }) {
  const { deliveryInfo, setChannel } = useCart();
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-14" data-testid={testPrefix}>
      <div className="rounded-3xl bg-white border border-neutral-200 px-6 py-7 sm:px-8 flex flex-col md:flex-row md:items-center gap-5">
        <p className="text-sm sm:text-base text-neutral-700 leading-relaxed max-w-2xl md:flex-1" data-testid={`${testPrefix}-line`}>{DELIVERY_BAND}</p>
        <div className="flex flex-wrap items-center gap-2 shrink-0">
          {deliveryInfo?.available && (
            <Link to="/store/restaurant" onClick={() => setChannel("delivery")} data-testid={`${testPrefix}-direct`}
              className="inline-flex items-center gap-1.5 rounded-full bg-[#E04F33] text-white hover:bg-[#c34a3e] font-bold text-sm px-4 py-2 transition-colors">
              <Bike size={15} aria-hidden="true" /> Order delivery from us
            </Link>
          )}
          {DELIVERY_APPS.map((a) => (
            <a key={a.key} href={a.url} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-${a.key}`}
              className="inline-flex items-center rounded-full border border-neutral-300 bg-white hover:border-black font-bold text-sm px-4 py-2 transition-colors">
              {a.badge ? <img src={a.badge} alt={`Order on ${a.label}`} className="h-5" /> : a.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
